import { NgModule } from '@angular/core';
import { ToggleClassDirective } from '@df/ui/toggle/toggle-class.directive';
import { ToggleDirective } from '@df/ui/toggle/toggle.directive';

@NgModule({
    imports: [ToggleDirective, ToggleClassDirective],
    exports: [ToggleDirective, ToggleClassDirective]
})
export class ToggleModule {}
